<template>
  <div class="container">
    <div class="left">
        <!-- <a-tree checkable v-model="checkedKeys" @check="onCheck" :treeData="permissions">
		 		</a-tree> -->
        <a-tree checkable v-model="checkedKeys" @check="onCheck" :treeData="permissions"  :replace-fields="replaceFields">
				</a-tree>

			<!-- <search-tree :treeData="deptTree" :dataList="dataList" :expandedKeys="expandedKeys" :holderText="holderText" @select="handleSelect">
			</search-tree> -->
	</div>
    
  </div>
</template>

<script>
import {
		getPermissions,
		getRolePermIds,
		saveRole,
		list_role,
		getDeptList,
	} from '@/api/system'
export default {
  data() {
    return {
      permissions: [],
      checkedKeys: '',
      replaceFields: {
        title: 'menuName',
        key: 'menuId'
      }
    }
  },
  created() {
    this.getData()

  },
  methods: {
    onCheck() {

    },
    getData() {
      getPermissions().then(res => {
        // res.rows.forEach(item => {
        //   Object.assign(item, {
        //     title: item.menuName,
        //     value: item.menuId

        //   })
          
        //   if(item.children) {
        //     item.forEach(item1 => {
        //     Object.assign(item1, {
        //       title: item.menuName,
        //       value: item.menuId

        //   })

        //     })

        //   }
          
        // });
        this.permissions = res.rows
        console.log(this.permissions,res.rows, 'this.permissions=====================')
					// this.buildtree(res.rows, this.permissions, 0)
				})
      //  getRolePermIds(1).then(res => {
      //   console.log(res, 'res11111111111111111111111111111111111')
      //   this.permissions = res
			// 			// const pidSet = new Set(res.map(m => m.parentId).filter(id => id > 0))
			// 			// this.pidSet = pidSet
			// 			// // 因为antd 树插件勾选父节点会导致所有子节点选中,所以过滤所有父节点
			// 			// this.checkedKeys = res.map(m => m.menuId).filter(id => !pidSet.has(id))
			// 			// console.log(this.pidSet,this.checkedKeys,res,222)
			// 		})
    }
   

  }

}
</script>

<style scoped>
.left {
		width: 40%;
		height: 100%;
		overflow-y: scroll;
		float: left;
	}

</style> 